module.exports = __webpack_public_path__ + "static/media/tyler.f10413a0.png";